import React, { Component } from "react";
import { connect } from "react-redux";
import { alltimings } from "../../js/order-grouping";
import MenuItemTemplate from "./MenuItemTemplate";
import auth, { getLocale2 } from "../../js/auth";

// Props you might need:
// {
//   customer,
//   customerCountByPayer,
//   id,
//   price,
//   myStatus,
//   alltimings,
//   timings,
//   statesShown,
//   orderIds,
//   orders,
//   menuItem,
//   local,
//   paid,
//   state,
//   printed,
//   previousState,
//   modificationTimeStamp,
//   featureEnabled,
//   cancelOrder,
//   incrementOrder,
//   getTableMate,
//   getDiscount,
//   getImageById,
//   isGeneratedOrder,
//   getMenuItem,
//   getCategoryProperty,
//   server,
//   war,
//   tableNumber,
//   currencyRound
// }

class OrdersByCustomer extends Component {
    renderOrdersForTiming(t, timingOrders) {
        const {
            customer,
            orderIds,
            myStatus,
            local,
            state,
            paid,
            printed,
            previousState,
            modificationTimeStamp,
            menuItem,
            featureEnabled,
            cancelOrder,
            incrementOrder,
            getMenuItem,
            getCategoryProperty,
            server,
            war,
            isGeneratedOrder,
        } = this.props;

        return timingOrders.sort((a, b) => a.customPrice - b.customPrice == 0 ? a.firstId - b.firstId : a.customPrice - b.customPrice).filter(o => o.orderIds[0] > 0).map((o, idx) => {
            const isOld = new Date().getTime() - o.modificationTimeStamp > 180000;

            return (
                <div
                    key={idx}
                    id={o.orderIds[0]}
                    ids={"morder" + JSON.stringify(o.orderIds).replace(/[\[\],]/g, "-")}
                    customerid={customer?.id}
                    order={o.orderIds}
                    level="3"
                    className="kiosk-byCustomer kiosk-menuItem-order"
                >
                    {/* Order state indicators */}
                    <div
                        id={`order${o.id}`}
                        order={o.id}
                        className={`kiosk-state ${o.state}`}
                    />

                    {/* Order content */}
                    <div
                        id={`order${o.orderIds[0]}`}
                        order={o.orderIds}
                        customerid={customer?.id}
                        timing={o.timing}
                        className={`kiosk-byCustomer ${o.paid ? "state-paid" : "draggable"} ${o.state} kiosk-menuItem-order`}
                    >
                        {/* Here you would render your MenuItem template */}
                        <MenuItemTemplate menuItem={o.menuItem} o={o} cancelOrder={cancelOrder} incrementOrder={incrementOrder} />


                    </div>
                </div>
            );
        });
    }

    render() {
        const {
            customer,
            price,
            myStatus,
            timings,

            local,
        } = this.props;

        var statesShown = this.props.statesShown;

        if (customer) {
            return (
                <li
                    id={customer.id}
                    level="2"
                    className="list-group-item"
                >

                    {/* Price */}

                    {/* Timings list */}
                    <div >
                        <ul className="list-group" style={{ position: "relative" }}>
                            {alltimings.map((t) =>
                                myStatus.restaurant_settings.timings[t].enabled ? (
                                    <li
                                        key={t}
                                        timing={t}
                                        id={customer.id}
                                        className={`${timings[t] ? "alwaysVisible" : "hidden3"
                                            } timing list-group-item ui-droppable`}
                                    >
                                        {Object.keys(timings).filter((tt) => t !== tt).length > 0 && (
                                            <span className="timingLabel">
                                                {local.course +
                                                    ": " +
                                                    getLocale2(
                                                        myStatus.restaurant_settings.timings[t].langs
                                                    ).name}
                                            </span>
                                        )}
                                        {/* Render orders for this timing */}
                                        {this.renderOrdersForTiming(
                                            t,
                                            Object.values(timings).flatMap((to) =>
                                                to.timing === t ? to.orders : []
                                            )
                                        )}
                                    </li>
                                ) : null
                            )}

                        </ul>

                        {/* Discounts */}
                        {(statesShown === "selected"
                            ? customer.selected_order_discount
                            : customer.discount) > 0 && (
                                <div className="discounts">
                                    {(
                                        (statesShown.indexOf("selected") >= 0 ||
                                            statesShown.indexOf("ordered") >= 0
                                            ? customer.selected_order_discountComment
                                            : customer.discountComment
                                        )
                                            .split(";")
                                            .filter((s) => s)
                                    ).map((s, idx) => {
                                        const parts = s.split(",");
                                        return (
                                            <React.Fragment key={idx}>
                                                <div className="discountName">
                                                    {this.getDiscount(parts[0]).name} {parts[2]}
                                                </div>
                                                <div
                                                    className="menuItem-price"
                                                    style={{
                                                        transform: "unset",
                                                        top: 0,
                                                        paddingTop: 0,
                                                        minWidth: "7rem",
                                                        paddingRight: ".8rem",
                                                        alignSelf: "center",
                                                    }}
                                                >
                                                    <div>-{auth.round(parts[1])}</div>
                                                    <div style={{ fontSize: ".5rem" }}>
                                                        {myStatus.restaurant_base_currency.name}
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            )}
                    </div>
                </li>
            );
        }

        // ELSE CASE (no tableMate)
        return (
            <li
                id={customer?.id}
                level="2"
                className="customer customer-droppable list-group-item ui-droppable main"
            >
                {/* Similar fallback rendering… */}
                <span className="menuItem-price badge">
                    <div>{price}</div>
                    <div style={{ fontSize: ".5rem" }}>
                        {myStatus.restaurant_base_currency.name}
                    </div>
                </span>
                {/* TODO: repeat similar structure as above */}
            </li>
        );
    }

    getDiscount = (discountId) => {
        return this.props.myStatus.restaurant_discounts.find(d => d.id == discountId);
    }
}

const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            menuCategories: props.rootReducer.menuCategories ? props.rootReducer.menuCategories.sort((a, b) => b.entityType.localeCompare(a.entityType)).filter(c => c.isActive && c.isTop && c.activeMenuItems.length > 0) : [],
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
        };
    }
    return {};
};

export default connect(mapStateToProps)(OrdersByCustomer);
